module.exports = __webpack_public_path__ + "static/media/plus.886f7069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/plus.svg
// module id = 785
// module chunks = 0